// extracted by mini-css-extract-plugin
module.exports = {"root":"LeftColumn_root__1SZfl","content":"LeftColumn_content__1iUyX","footer":"LeftColumn_footer__9ZDp_","footerContent":"LeftColumn_footerContent__1QkJp"};